import { Flex } from "@maxhub/max-ui"

export const FlexExample = {
    title: 'Flex',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'gap',
            label: 'gap',
            type: 'text',
            tsType: ['string', 'number'],
            default: '12',
        },
        {
            name: 'gapX',
            label: 'gapX',
            type: 'text',
            tsType: ['string', 'number'],
            default: '12',
        },
        {
            name: 'gapY',
            label: 'gapY',
            type: 'text',
            tsType: ['string', 'number'],
            default: '12',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
        {
            name: 'display',
            label: 'display',
            type: 'enum',
            tsType: ['"flex"', '"inline-flex"'],
            default: 'flex',
            options: ['flex', 'inline-flex'],
        },
        {
            name: 'direction',
            label: 'direction',
            type: 'enum',
            tsType: ['"row"', '"column"', '"row-reverse"', '"column-reverse"'],
            default: 'row',
            options: ['row', 'column', 'row-reverse', 'column-reverse'],
        },
        {
            name: 'align',
            label: 'align',
            type: 'enum',
            tsType: ['"center"', '"flex-start"', '"flex-end"', '"baseline"', '"stretch"'],
            default: 'center',
            options: ['center', 'flex-start', 'flex-end', 'baseline', 'stretch'],
        },
        {
            name: 'justify',
            label: 'justify',
            type: 'enum',
            tsType: ['"center"', '"start"', '"end"', '"space-between"'],
            default: 'center',
            options: ['center', 'start', 'end', 'space-between'],
        },
        {
            name: 'wrap',
            label: 'wrap',
            type: 'enum',
            tsType: ['"wrap"', '"nowrap"', '"wrap-reverse"'],
            default: 'nowrap',
            options: ['wrap', 'nowrap', 'wrap-reverse'],
        },
    ],

    Preview({ props }){
        const { gap, gapX, gapY, asChild, display, direction, align, justify, wrap, ...rest } = props

        const boxStyle = {
            backgroundColor: 'var(--background-surface-secondary)',
            height: 75,
            width: 75,
            flexShrink: 0
        }

        return (
            <Flex
                gap={Number(gap)}
                gapX={Number(gapX)}
                gapY={Number(gapY)}
                display={display}
                direction={direction}
                align={align}
                justify={justify}
                wrap={wrap}
                style={{ width: '100%' }}
                {...rest}
            >
                <div style={boxStyle} />
                <div style={boxStyle} />
                <div style={boxStyle} />
                <div style={boxStyle} />
                <div style={boxStyle} />
            </Flex>
        )
    },

    getCode(props){
        const { gap, gapX, gapY, display, direction, align, justify, wrap } = props
        const attrs = []

        if (gap !== '12') attrs.push(`gap={${gap}}`)
        if (gapX !== '12') attrs.push(`gapX={${gapX}}`)
        if (gapY !== '12') attrs.push(`gapY={${gapY}}`)
        if (display !== 'flex') attrs.push(`display="${display}"`)
        if (direction !== 'row') attrs.push(`direction="${direction}"`)
        if (align !== 'center') attrs.push(`align="${align}"`)
        if (justify !== 'center') attrs.push(`justify="${justify}"`)
        if (wrap !== 'nowrap') attrs.push(`wrap="${wrap}"`)

        const attrString = attrs.length > 0 ? '\n  ' + attrs.join('\n  ') + '\n' : ''

        return `<Flex${attrString}>
  <div style={{ backgroundColor: 'var(--background-surface-secondary)', height: 75, width: 75 }} />
  <div style={{ backgroundColor: 'var(--background-surface-secondary)', height: 75, width: 75 }} />
  <div style={{ backgroundColor: 'var(--background-surface-secondary)', height: 75, width: 75 }} />
  <div style={{ backgroundColor: 'var(--background-surface-secondary)', height: 75, width: 75 }} />
  <div style={{ backgroundColor: 'var(--background-surface-secondary)', height: 75, width: 75 }} />
</Flex>`
    }

}